import * as Long from "long";
import { ofType } from "redux-observable";
import { from } from "rxjs";
import { retry, switchMap } from "rxjs/operators";
import { MarketConstants } from "../../../constants/MarketConstants";
import { selectContractCooldownBuffAmount } from "../../../selectors/selectBuffsInfo";
import { selectContractOrder, selectContractRewardInfoById, } from "../../../selectors/selectContractInfo";
import { selectIsEventRunningByEventType } from "../../../selectors/selectEventInfo";
import { CommandCode, } from "../../../utils/network/generated/protoTypes";
import { actionAddPelletsOnContractFulfillAnimation } from "../../animation/actionPelletAnimations";
import { EventType } from "../../balancing/types/BalancingCore";
import { actionInventoryInfoAddResource, actionInventoryInfoRemoveResource, } from "../../info/inventory/actionInventoryInfo";
import { actionPlayerLeagueInfoAddPoints } from "../../info/league/actionPlayerLeagueInfo";
import { actionPlayerInfoAddXp } from "../../info/player/actionPlayerInfo";
import { actionModalClose } from "../../modals/actionModal";
import { IdModal } from "../../modals/IdModal";
import { actionContractInfo, actionContractStartCooldown, TypeActionContractInfo, } from "../actionContractInfo";
export var epicContractFulfill = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionContractInfo.Fulfill), switchMap(function (action) {
        var state = state$.value;
        return deps.netSend({
            id: CommandCode.FulfillContract,
            props: {
                contractId: action.contractId,
                farmId: state.playerBase.base.baseId,
                playerId: state.playerInfo.playerId,
            },
        });
    }), retry(), switchMap(function (res) {
        var state = state$.value;
        var contractOrders = selectContractOrder(state, res.contractId);
        var removeInventory = contractOrders
            ? contractOrders.map(function (inventory) {
                return {
                    amount: Long.fromValue(inventory.amount),
                    stageId: 0,
                    typeId: inventory.resourceId,
                };
            })
            : undefined;
        var contractCooldownBuff = selectContractCooldownBuffAmount(state, MarketConstants.ContractCooldownTime);
        var actions = [
            actionContractInfo(res),
            actionContractStartCooldown(contractCooldownBuff),
            actionModalClose(IdModal.Market),
            actionInventoryInfoAddResource(res.earnings),
        ];
        var rewardInfo = selectContractRewardInfoById(state, res.contractId);
        if (rewardInfo) {
            actions.push(actionPlayerInfoAddXp(Long.fromValue(rewardInfo.buffPlayerXpAmount || Long.ZERO).add(rewardInfo.playerXp)));
            actions.push(actionAddPelletsOnContractFulfillAnimation(rewardInfo));
            if (selectIsEventRunningByEventType(state, EventType.PlayerLeague)) {
                actions.push(actionPlayerLeagueInfoAddPoints(Long.fromValue(rewardInfo.marketXp), EventType.PlayerLeague));
            }
        }
        // TODO: Add adventure xp when implemented
        if (removeInventory) {
            actions.push(actionInventoryInfoRemoveResource(removeInventory));
        }
        return from(actions);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/market/epics/epicContractFulfill.ts
// module id = 1990
// module chunks = 3